import React from "react";
import { Outlet, useParams } from "react-router-dom";
import { TeamsProvider } from "./teams-provider";
import { MembersProvider } from "./members-provider";
import DemoBarTeam from "../../components/demo-bar-team";
import { ActiveIntegrationsProviderTeams } from "./dashboard/active-integrations-provider-teams";
import Portal from "../../components/portal";
import { TeamProvider } from "./team/team-provider";
import DemoBarDemo from "../../components/demo-bar-demo";

const TeamsIndex = () => {
    const { teamId } = useParams();
    return (
        <TeamsProvider>
            <MembersProvider>
                <ActiveIntegrationsProviderTeams teamId={teamId}>
                    <TeamProvider>
                        <Portal>
                            <DemoBarTeam />
                            <DemoBarDemo />
                        </Portal>
                        <Outlet />
                    </TeamProvider>
                </ActiveIntegrationsProviderTeams>
            </MembersProvider>
        </TeamsProvider>
    );
};

export default TeamsIndex;
